// Shared Reg M style fragments (PreClear and History).

// Visible keyboard focus for MUI ButtonBase components (buttons, icon buttons, chips, links).
export const focusRing = { "&.Mui-focusVisible": { outline: "2px solid", outlineColor: "primary.main", outlineOffset: 2 } };

// Minimum touch target height in pixels.
export const TOUCH = 40;
